// Fotos del chat (decisión D53): se achican en el celular antes de subir, como en el chat del personal (D39): 1600 px
// de lado como máximo y JPEG 80. Respeta la orientación de la cámara y pone fondo blanco a los PNG transparentes.

export const LADO_MAXIMO = 1600;
export const CALIDAD_JPEG = 0.8;
/** El mismo tope que la API: hasta 8 MB por foto (ya achicada, casi nunca llega). */
export const MAX_BYTES_FOTO = 8 * 1024 * 1024;

/** Medidas finales manteniendo la proporción; nunca agranda. */
export function medidasReducidas(ancho: number, alto: number, max = LADO_MAXIMO): { ancho: number; alto: number } {
  if (!(ancho > 0 && alto > 0)) return { ancho: 1, alto: 1 };
  const factor = Math.min(1, max / Math.max(ancho, alto));
  return { ancho: Math.max(1, Math.round(ancho * factor)), alto: Math.max(1, Math.round(alto * factor)) };
}

export interface FotoReducida {
  blob: Blob;
  ancho: number;
  alto: number;
  mime: 'image/jpeg';
}

export async function achicarFoto(archivo: Blob): Promise<FotoReducida> {
  let bmp: ImageBitmap;
  try {
    bmp = await createImageBitmap(archivo, { imageOrientation: 'from-image' });
  } catch {
    throw new Error('No pudimos leer esa foto. Probá con otra (JPG o PNG).');
  }
  const { ancho, alto } = medidasReducidas(bmp.width, bmp.height);
  const lienzo = document.createElement('canvas');
  lienzo.width = ancho;
  lienzo.height = alto;
  const ctx = lienzo.getContext('2d');
  if (!ctx) throw new Error('El navegador no deja preparar la foto');
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, ancho, alto);
  ctx.drawImage(bmp, 0, 0, ancho, alto);
  bmp.close();
  const blob = await new Promise<Blob | null>((ok) => lienzo.toBlob(ok, 'image/jpeg', CALIDAD_JPEG));
  if (!blob) throw new Error('No pudimos preparar la foto');
  if (blob.size > MAX_BYTES_FOTO) throw new Error('La foto es muy grande (hasta 8 MB)');
  return { blob, ancho, alto, mime: 'image/jpeg' };
}
